export default __webpack_public_path__ + "media/zurb/img/home/home-work-darby-071d53cd69305bd81e59d5005157fc49.png";